<template>
  <pt-save-sign-notes class="pt-save-sign-notes__withData" :name="name" :id="id" :signDetail="signDetail" :hospitalList="hospitalList"
  :provinceList="provinceList" @exportSign="exportSign" :exportLoading="exportLoading" :loading="loading" :detailLoading="detailLoading"></pt-save-sign-notes>
</template>

<script>
import PtSaveSignNotes from './index'
export default {
  name: 'pt-save-sign-notes__withData',
  components: {
    'pt-save-sign-notes': PtSaveSignNotes
  },
  props: {
    name: {
      type: String
    },
    id: {
      type: String
    }
  },
  data () {
    return {
      signDetail: {},
      hospitalList: [],
      provinceList: [],
      exportLoading: false,
      detailLoading: false,
      provinceLoading: false
    }
  },
  computed: {
    loading () {
      return this.detailLoading || this.provinceLoading
    }
  },
  methods: {
    exportSign (data) {
      this.exportLoading = true
      this.$store.dispatch('exportSign', data).then(res => {
        this.exportLoading = false
        this.$message.success('数据准备中，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可')
      }).catch(err => {
        this.exportLoading = false
        this.$message.error(err || '导出失败')
      })
    },
    getSignDetail () {
      this.detailLoading = true
      this.$store.dispatch('getSignDetail', this.id).then(res => {
        this.detailLoading = false
        this.signDetail = res
      }).catch(err => {
        this.detailLoading = false
        this.$message.error(err || '获取报名详情失败')
      })
    },
    getHospitalList () {
      let data = {
        pageableParam: {
          page: 0,
          size: 9999
        }
      }
      this.$store.dispatch('getHospitalList', data).then(res => {
        this.hospitalList = res.data
      }).catch(err => {
        this.$message.error(err || '获取医院列表失败')
      })
    },
    getDivision () {
      let data = {
        provinceGbCode: 0,
        cityGbCode: 0
      }
      this.provinceLoading = true
      this.$store.dispatch('getDivision', data).then(res => {
        this.provinceList = res
        this.provinceLoading = false
      }).catch(err => {
        this.provinceLoading = false
        this.$message.error(err || '获取省份列表失败')
      })
    }
  },
  created () {
    this.getSignDetail()
    // this.getHospitalList()
    this.getDivision()
  }
}
</script>
